import { render } from "./stronaLogowaniaBody.vue?vue&type=template&id=f0474b72&scoped=true"
import script from "./stronaLogowaniaBody.vue?vue&type=script&lang=js"
export * from "./stronaLogowaniaBody.vue?vue&type=script&lang=js"

import "./stronaLogowaniaBody.vue?vue&type=style&index=0&id=f0474b72&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0474b72"]])

export default __exports__